<template>
  <form @submit.prevent="save(v)" class="one d-block mb-3 animation-sortable-item" :class="{'one-done': v.is_done}">
    <transition name="animation-slide">
    <div v-if="!isSelected(v)">
      <div class="form-check form-switch form-switch-lg">
        <input @click.stop="v._is_done = !v._is_done; select(v);" v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultCloseParam_${v.id}`" class="form-check-input">
        <div @click.stop="select(v);" class="form-check-label mx-3 mt-2"><span class="one-id">{{ v.id }}</span>{{ v.param.name }}</div>
        <!--label @click.stop="select(v);" class="one-toggle-info-button" :for="`flexSwitchCheckDefaultCloseParam_${v.id}`"><i class="bi bi-arrow-down-circle-fill"></i></label-->
        <i v-if="v.synchronizating" class="one-important-status spinner-border spinner-border-sm"><span class="visually-hidden">Синхронизация...</span></i>
      </div>
    </div>
    <div v-else>
      <div class="form-check form-switch form-switch-lg">
        <input v-model="v._is_done" type="checkbox" role="switch" :id="`flexSwitchCheckDefaultOpenParam_${v.id}`" class="form-check-input">
        <div @click.stop="deselect(v);" class="form-check-label mx-3 mt-2"><span class="one-id">{{ v.id }}</span>{{ v.param.name }}</div>
        <!--label @click.stop="deselect(v);" class="one-toggle-info-button" :for="`flexSwitchCheckDefaultOpenParam_${v.id}`"><i class="bi bi-arrow-up-circle-fill"></i></label-->
      </div>
      <div class="mt-3">
        <!-- Param variants -->
        <div class="mb-3">
          <div v-if="+v.param.type === ParamModel.TYPE_STRING">
            <textarea class="form-control" v-model="v.value" rows="4" />
          </div>
          <div v-else-if="+v.param.type === ParamModel.TYPE_IMAGE">
            <img :alt="v.param.type" :src="getImageByModel(v, `param-photo-${v.id}`)" :id="`param-photo-${v.id}`" :style="`display: ` + (v.value ? 'block' : 'none')" class="one-photo" />
            <div>
              <!-- To android/ios platform -->
              <div class="offcanvas offcanvas-bottom" tabindex="-1" :id="`offcanvasParamPhoto` + v.id" aria-labelledby="offcanvasParamPhotoLabel">
                <div class="offcanvas-header">
                  <h5 class="offcanvas-title" id="offcanvasParamPhotoLabel">Что хотите сделать?</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" :id="`param--btn-close-photo-selector-${v.id}`"></button>
                </div>
                <div class="offcanvas-body pt-0">
                  <button type="button" @click="takePhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Открыть камеру</button>
                  <button type="button" @click="selectPhoto(v)" class="btn btn-primary w-100 mb-3 rounded-pill">Выбрать из галереи</button>
                </div>
              </div>
              <!-- /To android/ios platform -->
              <!-- To web platform -->
              <div class="d-none">
                <input type="file" @change="attachFile($event, v, this)" :id="`param--append-file-${v.id}`" accept="capture=camera,image/*" />
              </div>
              <!-- /To web platform -->
            </div>
            <button v-if="['android', 'ios'].includes(PLATFORM)" type="button" class="btn btn-secondary w-100" data-bs-toggle="offcanvas" :data-bs-target="`#offcanvasParamPhoto${v.id}`" aria-controls="offcanvasParamPhoto">
              <i class="bi bi-camera-fill me-2"></i>Фото
            </button>
            <button v-else type="button" @click="attachFileDialog(v)" class="btn flex-fill btn-secondary w-100 me-3">
              <span v-if="hasAttachedFile(v)" class="text-success">Прикреплено</span>
              <span v-else><i class="bi bi-camera-fill me-2"></i>Фото</span>
            </button>
          </div>
          <div v-else-if="+v.param.type === ParamModel.TYPE_NUMBER">
            <input v-model="v.value" type="number" class="form-control">
          </div>
          <div v-else-if="+v.param.type === ParamModel.TYPE_DATETIME">
            <input v-model="v.value" type="date" class="form-control">
          </div>
          <div v-else-if="+v.param.type === ParamModel.TYPE_TIME">
            <div class="d-flex justify-content-between">
              <div class="flex-fill w-50 me-3 text-center">
                <label class="form-label mb-0">Часы:</label>
                <select :value="parseInt(v.value_hours)" @change="e => v.value_hours = e.target.value" class="form-control text-center">
                  <option :value="h-1" v-for="h in 24">
                    {{ HH(h-1) }}
                  </option>
                </select>
              </div>
              <div class="flex-fill w-50 text-center">
                <label class="form-label mb-0">Минуты:</label>
                <select :value="parseInt(v.value_mins)" @change="e => v.value_mins = e.target.value" class="form-control text-center">
                  <option :value="m-1" v-for="m in 60">
                    {{ MM(m-1) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- /Param variants -->
        <short-time-line :model="v" />
        <div class="d-flex justify-content-between">
          <div class="w-50 me-3">&nbsp;</div>
          <button type="submit" class="btn flex-fill btn-primary w-50">Сохранить</button>
        </div>
      </div>
    </div>
    </transition>
  </form>
</template>

<script>
import { selectPhoto, takePhoto } from "@/helpers/camera";
import ShortTimeLine from "@/components/ShortTimeLine";
import getImageByModel from "@/mixins/getImageByModel";
import nodeList from "@/mixins/nodeList";
import { ParamModel } from "@/models/ParamModel";
import EnvConfig from "@/env";

export default {
  props: [
    "selectedParams",
    "v",
  ],
  data() {
    return {
      ParamModel,
      PLATFORM: EnvConfig.PLATFORM,
    }
  },
  components: {
    ShortTimeLine
  },
  mixins: [
    getImageByModel,
    nodeList,
  ],
  methods: {
    takePhoto(model) {
      takePhoto(base64image => {
        const img = document.getElementById(`param-photo-${model.id}`);
        img.src = model.value = `${base64image}`;
        img.style.display = 'block';
      });
      this.closeSelectPhotoPopup(model);
    },
    selectPhoto(model) {
      selectPhoto(base64image => {
        const img = document.getElementById(`param-photo-${model.id}`);
        img.src = model.value = `${base64image}`;
        img.style.display = 'block';
      });
      this.closeSelectPhotoPopup(model);
    },
    closeSelectPhotoPopup(model) {
      document.getElementById(`param--btn-close-photo-selector-` + model.id).click();
    },
    attachFileDialog(model) {
      const inputFile = document.getElementById(`param--append-file-${model.id}`);
      inputFile.click();
    },
    hasAttachedFile(model) {
      const inputFile = document.getElementById(`param--append-file-${model.id}`);
      return inputFile?.files?.length;
    },
    async attachFile(event, model) {
      const getBase64 = file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };
      const file = event.target.files.length ? event.target.files[0] : null;

      if (!file) {
        return;
      }
      try {
        model.value = await getBase64(file);
      } catch (e) {
        console.error('error uploading file', e);
      }
    },
    select(m) {
      this.selectedParams.push(+m.id);
    },
    deselect(m) {
      this.$emit(
        'selectedParamsUpdater',
        this.selectedParams.filter(id => id !== +m.id)
      );
    },
    isSelected(m) {
      // return true;
      return this.selectedParams.includes(+m.id);
    },
    save(m) {
      this.deselect(m);
      m.is_done = m._is_done;
      m.flush();
    },
  }
}
</script>